<app-page-header [title]="title.getTitle()"></app-page-header>
<section class="page-area">
  <div class="padded-content top-bottom-padding">
    <app-content-header title="Your have been logged out of the application"></app-content-header>
    <button (click)="login()" class="btn btn-primary">Log in again</button>
  </div>
</section>
